"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveOrders = exports.getHistoryOrders = exports.useCustomOrders = exports.CustomOrderCreatedSubject = void 0;
/**
 * 提供手动交易账户的订单列表
 * 需支持的功能
 * 1. 下拉刷新
 * 2. 上拉加载
 * 3. 监听websocket
 */
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const interface_1 = require("../../../interface");
const CustomAssetsProvider_1 = require("../../Assets/CustomAssetsProvider");
const Trade_1 = require("../../Trade");
const rx_1 = require("../CustomTPSLProvider/rx");
exports.CustomOrderCreatedSubject = new rxjs_1.Subject();
/**
 *
 * @param props
 * return
 * orders 订单
 * observerWSOrders 订阅wss
 *
 */
const CustomOrdersPageLength = 12;
function isFutureOrder(order) {
    const { symbol } = order;
    return symbol.includes(".PERP");
}
function isNewOrder(preOrder, compareData) {
    let isNewOrder = false;
    if (compareData.timestamp > preOrder.timestamp) {
        isNewOrder = true;
    }
    else if (compareData.timestamp === preOrder.timestamp) {
        isNewOrder = Number(compareData.id) > Number(preOrder.id);
    }
    return isNewOrder;
}
function getNewState(prevState, newOrder) {
    const newState = prevState.slice();
    const { status, id, source } = newOrder;
    // 如果该订单id的订单已经存在，则是他的下标index
    const repeatedIndex = prevState.findIndex((e) => e.id === id);
    // 如果该订单id的订单已经存在，则是他的订单数据
    const repeatedData = repeatedIndex >= 0 ? prevState[repeatedIndex] : undefined;
    // 最后一个订单，订单列表中下标为0的数据
    const lastOrder = prevState.length ? prevState[0] : undefined;
    // 判断notifyChange
    const notifyChange = (() => {
        var _a, _b, _c, _d;
        // 判断是否由条件单触发的订单，如果是由条件单触发的订单，则不弹出任何toast
        if (source === interface_1.OrderSourceType.TRIGGER) {
            return undefined;
        }
        const symbolArr = newOrder.symbol.split("/");
        const base = symbolArr.length ? symbolArr[0] : "";
        const checkBaseIsFutures = base === null || base === void 0 ? void 0 : base.endsWith(".PERP");
        const isFutures = !!newOrder.position_side || checkBaseIsFutures;
        const oriQty = String(newOrder.amount);
        const qty = String(newOrder.qty);
        // 一. 订单正常完成
        if (status === interface_1.OrderStatus.CLOSE) {
            if (isFutures) {
                if (newOrder.amount === newOrder.qty) {
                    return interface_1.OrderChangedNotifyType.complete;
                }
            }
            else {
                return interface_1.OrderChangedNotifyType.complete;
            }
        }
        const isReduceOnly = isFutures &&
            ((newOrder.side === interface_1.CustomOrderSide.SELL && newOrder.position_side === interface_1.FuturePositionSide.LONG) ||
                (newOrder.side === interface_1.CustomOrderSide.BUY && newOrder.position_side === interface_1.FuturePositionSide.SHORT));
        // FIX:使用SafeDecimal进行对比
        const isQtyChanged = !new trade_utils_lib_1.SafeDecimal(oriQty).eq(new trade_utils_lib_1.SafeDecimal(qty));
        // 二. 订单发生裁剪, 并且为第一次推送
        if (isReduceOnly && isQtyChanged) {
            // 是否为最新的单
            const isFirstOrder = (lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.id) === newOrder.id;
            // 是否是提交后的第一次推送
            const isFirstTime = ((_b = (_a = lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.info) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.state) === "SUBMITTED" && ((_d = (_c = newOrder.info) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.state) === "CONFIRMED";
            if (isFirstOrder && isFirstTime) {
                // 订单已完成 taker 单
                if (status === interface_1.OrderStatus.CLOSE) {
                    return interface_1.OrderChangedNotifyType.qtyChangedComplete;
                }
                // 订单未完成 maker 单
                if (status === interface_1.OrderStatus.OPEN) {
                    return interface_1.OrderChangedNotifyType.qtyChangedNotComplete;
                }
            }
        }
        // 三. 市价单被IOC取消或部分取消
        if (status === interface_1.OrderStatus.CANCELED && newOrder.type === interface_1.CustomOrderType.MARKET_QTY) {
            if (new trade_utils_lib_1.SafeDecimal(newOrder.filled).greaterThan(0)) {
                return interface_1.OrderChangedNotifyType.marketBeenIOCComplete;
            }
            else {
                return interface_1.OrderChangedNotifyType.marketBeenIOCCancelled;
            }
        }
    })();
    // 该订单被关闭或被撤销
    if (status !== interface_1.OrderStatus.OPEN) {
        // 现有的订单列表中不存该订单则忽略掉
        if (!repeatedData) {
            return { newState: prevState, notifyChange };
        }
        // 移除该订单
        newState.splice(repeatedIndex, 1);
        return { newState, notifyChange };
    }
    // 有已存在的订单, 更新该订单的状态
    if (repeatedData) {
        const newOrderData = Object.assign({}, repeatedData, newOrder);
        newState.splice(repeatedIndex, 1, newOrderData);
        return {
            newState,
            notifyChange,
        };
    }
    // 非市价单的情况插入列表中
    if (Trade_1.CalculateUtils.isFuturesMarket(newOrder.type) === false) {
        // 当前订单列表为空 直接插入
        if (!prevState.length) {
            newState.push(newOrder);
            return {
                newState,
                notifyChange,
            };
        }
        if (lastOrder) {
            // 要更新的订单比老的都要新，直接插到最前边
            if (isNewOrder(lastOrder, newOrder)) {
                newState.unshift(newOrder);
                return {
                    newState,
                    notifyChange,
                };
            }
            // 要更新的订单有可能是新的，因为在并行多单下单时，wss给过来的顺序并不能保证按时间顺序
            // 将该订单插入时间排序中
            if (Math.abs(newOrder.timestamp - lastOrder.timestamp) < 3000) {
                for (let index = 0; index < newState.length; index++) {
                    const element = newState[index];
                    if (isNewOrder(element, newOrder)) {
                        // 排在比列表中第一个比该订单老的前边
                        newState.splice(index, 0, newOrder);
                        break;
                    }
                    // 最后一个
                    if (index === newState.length - 1) {
                        newState.push(newOrder);
                        break;
                    }
                }
                return {
                    newState,
                    notifyChange,
                };
            }
        }
    }
    return { newState: prevState, notifyChange };
}
function getOrderIds(orders) {
    return orders.map((it) => it.id);
}
const NullArray = [];
const useCustomOrders = (props, active = true) => {
    var _a, _b;
    const { apiKey, symbol, orderStates, isHistory = false, accountType, symbolType, 
    //timeRange,
    onOrderStateChanged, limit = CustomOrdersPageLength, } = props;
    const [orderData, setOrderData] = (0, react_1.useState)();
    const hasMore = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (isHistory) {
            return !new trade_utils_lib_1.SafeDecimal(orderData === null || orderData === void 0 ? void 0 : orderData.next_page_cursor).eq(0);
        }
        else {
            return ((_b = (_a = orderData === null || orderData === void 0 ? void 0 : orderData.orders) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) >= limit;
        }
    }, [isHistory, limit, orderData === null || orderData === void 0 ? void 0 : orderData.next_page_cursor, (_a = orderData === null || orderData === void 0 ? void 0 : orderData.orders) === null || _a === void 0 ? void 0 : _a.length]);
    const [error, setError] = (0, react_1.useState)();
    const [refreshing, setRefreshing] = (0, react_1.useState)(true);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const initSuccess = (0, react_1.useRef)(false);
    /**校准之后的时间区间，结束时间需要加一天 */
    // FIXME:  先注释掉时间筛选
    // const timeRangeAdjusted = useMemo(() => adjustTimeRange(timeRange), [timeRange]);
    const changeOrderRef = (0, react_1.useRef)(onOrderStateChanged);
    changeOrderRef.current = onOrderStateChanged;
    /**缓存当前订单的map，用于快速查询订单 */
    // const orderMapRef = useRef<Map<string, IndexedData<CustomOrder>>>(new Map());
    const filterRef = (0, react_1.useRef)({ symbolType, symbol });
    const orderStatesValue = (0, react_1.useMemo)(() => (orderStates || []).join(","), [orderStates]);
    const loadingRef = (0, react_1.useRef)(false);
    // record filter symbol type & symbol
    (0, react_1.useEffect)(() => {
        filterRef.current = { symbolType, symbol };
    }, [symbolType, symbol]);
    const queryOrder = (0, react_1.useCallback)((page_cursor) => {
        const request = { accountType: accountType, limit };
        symbol && (request.symbol = symbol);
        symbolType && (request.symbol_type = symbolType);
        // FIXME:  先去掉时间筛选相关的逻辑
        // // 设置按照时间筛选的参数
        // const range = mergeTimeRange(timeRangeAdjusted, lastTime);
        // if (range) {
        //     range.endTime && (request.end_time = range.endTime);
        //     range.startTime && (request.start_time = range.startTime);
        // }
        if (page_cursor) {
            request.page_cursor = page_cursor;
        }
        if (isHistory) {
            // 只有在历史订单中才可以按照状态筛选
            if (orderStatesValue) {
                request.state = orderStatesValue;
            }
            // 适配ats单
            request.order_mode = isHistory
                ? [interface_1.QueryOrderMode.NORMAL, interface_1.QueryOrderMode.ALTERNATIVE, interface_1.QueryOrderMode.DELISTING].join(",")
                : interface_1.QueryOrderMode.NORMAL;
            // 历史订单需要过滤掉被拒绝的订单
            request.filter = "TRIGGER_REJECT";
        }
        return isHistory
            ? (0, FutureAPI_1.queryHistoryOrders)(request)
            : (0, FutureAPI_1.queryActiveOrders)(request).pipe((0, operators_1.tap)((data) => {
                // 通知订单数据发生变跟
                (0, rx_1.dispatchOrderChangedEvent)({ event: "update", ids: getOrderIds((data === null || data === void 0 ? void 0 : data.orders) || []) });
            }));
    }, [accountType, limit, symbol, symbolType, orderStatesValue, isHistory]);
    const _refresh = (0, react_1.useCallback)(() => {
        return queryOrder().pipe((0, operators_1.tap)((data) => {
            // const newOrders = data?.orders || [];
            // updateOrderMap(orderMapRef.current, newOrders);
            setError(null);
            setOrderData(data);
            initSuccess.current = true;
        }), (0, operators_1.catchError)((error) => {
            setError(error);
            // updateOrderMap(orderMapRef.current, []);
            setOrderData(undefined);
            throw error;
        }));
    }, [queryOrder]);
    const refreshWithLoading = (0, react_1.useCallback)(() => {
        // FIX:在查看历史订单时，用户可能会快速切换筛选项，所以关闭防重入逻辑
        if (!isHistory && loadingRef.current) {
            return;
        }
        setRefreshing(true);
        loadingRef.current = true;
        return _refresh().subscribe({
            next: (data) => {
                setRefreshing(false);
                loadingRef.current = false;
            },
            error: (error) => {
                setRefreshing(false);
                loadingRef.current = false;
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_refresh]);
    const loadMore = (0, react_1.useCallback)(() => {
        var _a;
        if (!orderData || !((_a = orderData.orders) === null || _a === void 0 ? void 0 : _a.length) || !hasMore || loadingRef.current) {
            return;
        }
        loadingRef.current = true;
        setLoading(true);
        return queryOrder(orderData.next_page_cursor).subscribe({
            next: (data) => {
                var _a;
                setError(null);
                const orders = (_a = data === null || data === void 0 ? void 0 : data.orders) !== null && _a !== void 0 ? _a : [];
                if (data) {
                    setOrderData((prevData) => {
                        var _a, _b;
                        const oldOrders = (_a = prevData === null || prevData === void 0 ? void 0 : prevData.orders) !== null && _a !== void 0 ? _a : [];
                        const newOrders = (_b = oldOrders.concat(orders)) !== null && _b !== void 0 ? _b : [];
                        // updateOrderMap(orderMapRef.current, newOrders, oldOrders.length, false);
                        return Object.assign(Object.assign({}, data), { orders: newOrders });
                    });
                }
                loadingRef.current = false;
                setLoading(false);
            },
            error: (error) => {
                loadingRef.current = false;
                setLoading(false);
            },
        });
    }, [queryOrder, orderData, hasMore]);
    // wss监听某条的变化
    (0, react_1.useEffect)(() => {
        if (isHistory) {
            return;
        }
        const wss$ = (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccountWebSocket()
            .getExchangeOrderObservable();
        if (!wss$) {
            return;
        }
        const sub = (0, rxjs_1.merge)(wss$.pipe((0, operators_1.map)((res) => res.originOrderData)), exports.CustomOrderCreatedSubject).subscribe({
            next: (data) => {
                if (!data) {
                    return;
                }
                const { symbol: fSymbol, symbolType: fType } = filterRef.current;
                // 过滤掉不满足条件的推送数据
                // 在筛选当前币对的情况下，过滤掉非当前币对的数据
                if (fSymbol && fSymbol !== data.symbol) {
                    return;
                }
                const isFuture = isFutureOrder(data);
                // 有合约订单被成交, 立即刷新仓位
                if (isFuture && data.status === interface_1.OrderStatus.CLOSE) {
                    (0, CustomAssetsProvider_1.refreshAccountDetail)();
                }
                // 过滤掉类型不匹配的币对
                if ((fType === "SPOT" && isFuture) || (fType === "PERP" && !isFuture)) {
                    return;
                }
                setOrderData((prevState) => {
                    var _a, _b, _c, _d, _e, _f;
                    const payload = getNewState((_a = prevState === null || prevState === void 0 ? void 0 : prevState.orders) !== null && _a !== void 0 ? _a : [], data);
                    const { newState, notifyChange } = payload;
                    if (notifyChange) {
                        (_b = changeOrderRef.current) === null || _b === void 0 ? void 0 : _b.call(changeOrderRef, data, notifyChange);
                    }
                    if (isFuture && ((_c = prevState === null || prevState === void 0 ? void 0 : prevState.orders) === null || _c === void 0 ? void 0 : _c.length) !== newState.length) {
                        const isRemove = newState.length < ((_e = (_d = prevState === null || prevState === void 0 ? void 0 : prevState.orders) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0);
                        // 注意，当收到新订单推送时，这个时候止盈止损单还没创建，所以这个时候去通知刷新止盈止损的列表么有意义，此处直接忽略新增订单的场景
                        if (isRemove) {
                            (0, rx_1.dispatchOrderChangedEvent)({ event: "remove", ids: [data.id] });
                        }
                    }
                    const newData = {
                        orders: newState,
                        next_page_cursor: (_f = prevState === null || prevState === void 0 ? void 0 : prevState.next_page_cursor) !== null && _f !== void 0 ? _f : "0",
                    };
                    return newData;
                });
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [isHistory]);
    // 默认调起一次, 登录状态发生改变时调起
    (0, react_1.useEffect)(() => {
        // FIX: 非active重复请求的问题
        let sub;
        if (!active) {
            // 第一次加载数据
            if (!initSuccess.current) {
                sub = refreshWithLoading();
            }
            return;
        }
        sub = refreshWithLoading();
        // FIX : 每次使用最新的筛选条件发起请求，但是不再进行防重入的处理
        return () => {
            sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
            loadingRef.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiKey, symbolType, symbol, orderStatesValue, isHistory]);
    (0, react_1.useEffect)(() => {
        if (!apiKey) {
            setOrderData(undefined);
        }
    }, [apiKey]);
    // FIXME:  先注释掉时间筛选，后续可能会支持
    // }, [apiKey, symbolType, symbol, orderStatesValue, timeRangeAdjusted]);
    // active变为活跃时自动调起一次
    const isFirstLoad = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        if (isFirstLoad.current) {
            isFirstLoad.current = false;
            return;
        }
        _refresh().subscribe({ next: () => { }, error: () => { } });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);
    const batchCancelOrders = (0, react_1.useCallback)(() => {
        var _a, _b;
        if (!((_a = orderData === null || orderData === void 0 ? void 0 : orderData.orders) === null || _a === void 0 ? void 0 : _a.length)) {
            return (0, rxjs_1.throwError)("no orders to cancel");
        }
        const needCancel = (_b = orderData === null || orderData === void 0 ? void 0 : orderData.orders) === null || _b === void 0 ? void 0 : _b.slice(0, 10).map((e) => {
            return { order_id: e.id, symbol: e.symbol, accountType: accountType };
        });
        return (0, Trade_1.cancelCustomOrders)(needCancel).pipe((0, operators_1.tap)(refreshWithLoading));
    }, [accountType, orderData, refreshWithLoading]);
    return {
        // 当且仅当登录之后，才返回数据
        orders: !!apiKey ? (_b = orderData === null || orderData === void 0 ? void 0 : orderData.orders) !== null && _b !== void 0 ? _b : NullArray : NullArray,
        refreshing,
        loading,
        error,
        hasMore,
        refresh: refreshWithLoading,
        loadMore,
        /**批量取消订单，并且刷新列表 */
        batchCancelOrders,
    };
};
exports.useCustomOrders = useCustomOrders;
/**获取历史订单 */
function getHistoryOrders(params) {
    return (0, FutureAPI_1.queryHistoryOrders)(params);
}
exports.getHistoryOrders = getHistoryOrders;
/**获取活跃订单 */
function getActiveOrders(params) {
    return (0, FutureAPI_1.queryActiveOrders)(params);
}
exports.getActiveOrders = getActiveOrders;
